import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";

export class ContactBookDetailController implements IOnInit {
  static $inject = ["environment", "$state",];
  contactBookDetail!: any;
  constructor() { }
  
  
  $onInit(): void {
    this.contactBookDetail = this.contactBookDetail.Results[0]
  }
}
